import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { ComingSoonTag } from './ComingSoonTag';

/** Shown in place of the credential form when a provider has no scraper. An empty space reads as a bug. */
export const UnsupportedProviderNotice = _ref => {
  let providerName = _ref.providerName;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginTop: '16px'
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Bill automation"), /*#__PURE__*/React.createElement(ComingSoonTag, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      marginTop: '8px'
    }
  }, providerName ? "".concat(providerName, " is not") : 'This provider is not', " covered by automatic bill retrieval, so there is nowhere to store a portal login for it. Bills for this utility are collected manually."));
};